import { PayloadAction, createSlice } from "@reduxjs/toolkit";
export interface AppSlice {
  collapsed: boolean;
  socketConnected: boolean;
}

const initialState: AppSlice = {
  collapsed: false,
  socketConnected: false,
};

export const appSlice = createSlice({
  name: "app",
  initialState: initialState,
  reducers: {
    toggleSidebarCollapse: (state, action: PayloadAction<boolean>) => {
      state.collapsed = action.payload;
    },
    setSocketConnected: (state, action: PayloadAction<boolean>) => {
      state.socketConnected = action.payload;
    },
  },
});

export const { toggleSidebarCollapse, setSocketConnected } = appSlice.actions;

export default appSlice.reducer;
